import React from 'react';
import { PROFESSIONS } from '../../data/professions';

const CompaniesList = ({ channel }) => {
  const profession = PROFESSIONS[channel];
  const isCaregiversUseCase = channel === 'caregivers';
  const isAssistedLivingUseCase = channel === 'assisted_living';
  const isBuzzInClientsUseCase = channel === 'buzz_in_clients';
  const isRoverUseCase = channel === 'rover';
  const isPetSittingUseCase = channel === 'pet_sitting';
  const isAirbnbUseCase = channel === 'airbnb';
  const isShortTermRentalsUseCase = channel === 'short_term_rentals';
  const isAmazonPackagesUseCase = channel === 'amazon_packages';
  const isGroceriesUseCase = channel === 'groceries';
  const isRoommatesUseCase = channel === 'roommates';
  const isPropertyAccessSoftwareUseCase = channel === 'property_access_software';

  const heading =
    isCaregiversUseCase || isAssistedLivingUseCase
      ? 'Ideal For'
      : isBuzzInClientsUseCase ||
        isRoverUseCase ||
        isPetSittingUseCase ||
        isAirbnbUseCase ||
        isShortTermRentalsUseCase ||
        isRoommatesUseCase ||
        isPropertyAccessSoftwareUseCase ||
        profession
      ? 'Perfect For'
      : 'Best Used With';

  let labels;
  if (profession) {
    labels = profession.marquee;
  } else if (isCaregiversUseCase) {
    labels = [
      'Home Health Aides',
      'Visiting Nurses',
      'Physical Therapists',
      'Meal Delivery Services',
      'Cleaning Services',
      'Family Members',
    ];
  } else if (isAssistedLivingUseCase) {
    labels = [
      'Home Health Aides',
      'Visiting Nurses',
      'Physical Therapists',
      'Mobility Assistants',
      'Meal Delivery Services',
      'Family Members',
    ];
  } else if (isBuzzInClientsUseCase) {
    labels = [
      'Therapists',
      'Consultants',
      'Tutors',
      'Personal Trainers',
      'Massage Therapists',
      'Life Coaches',
      'Tattoo Artists',
    ];
  } else if (isRoverUseCase) {
    labels = [
      'Dog Walkers',
      'Rover Sitters',
      'Doggy Daycare Pickups',
      'Mobile Groomers',
      'Pet Boarding Drop-offs',
      'Vet House Calls',
    ];
  } else if (isPetSittingUseCase) {
    labels = [
      'Pet Sitters',
      'Dog Walkers',
      'Cat Sitters',
      'Mobile Groomers',
      'House Sitters',
      'Doggy Daycare',
    ];
  } else if (isAirbnbUseCase) {
    labels = [
      'Airbnb Guests',
      'Cleaning Crews',
      'Co-hosts',
      'Maintenance',
      'Turnover Services',
      'Property Managers',
    ];
  } else if (isShortTermRentalsUseCase) {
    labels = [
      'Vacation Renters',
      'Cleaning Crews',
      'Property Managers',
      'Co-hosts',
      'Maintenance Vendors',
      'Turnover Services',
    ];
  } else if (isAmazonPackagesUseCase) {
    labels = ['Amazon', 'USPS', 'FedEx', 'UPS', 'DHL', 'Amazon Prime'];
  } else if (isGroceriesUseCase) {
    labels = ['Instacart', 'Amazon Fresh', 'Whole Foods', 'Walmart', 'Shipt', 'DoorDash'];
  } else if (isRoommatesUseCase) {
    labels = ['Roommates', 'Shared Apartments', 'Couples', 'House Shares', 'Subletters', 'Families'];
  } else if (isPropertyAccessSoftwareUseCase) {
    labels = ['Tenants', 'Guests', 'Deliveries', 'Cleaning Crews', 'Maintenance Teams', 'Vendors'];
  } else {
    labels = ['Postmates', 'Instacart', 'DoorDash', 'Amazon Prime', 'UberEats', 'GrubHub'];
  }

  const marquee = labels.map((label, index) => (
    <span key={index} class="mx-10">
      {label}
    </span>
  ));

  return (
    <>
      <div class="flex flex-row justify-center">
        <p class="pb-8 font-syne-bold text-xl text-slate-500 sm:pb-9 sm:text-2xl xl:pb-10">{heading}</p>
      </div>
      <div class="flex flex-col overflow-x-clip">
        <div class="z-0 bg-green-lowkey shadow-lg" style={{ boxShadow: '0 0 12px 12px #41E1B0' }} />
        <div class="relative flex overflow-x-hidden bg-green-lowkey">
          <div class="flex items-center justify-center py-3 font-montserrat-semi-bold text-lg text-black sm:text-xl lg:text-2xl">
            <div class="animate-marquee whitespace-nowrap">{marquee}</div>
            <div class="absolute top-3 animate-marquee2 whitespace-nowrap">{marquee}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompaniesList;
